import { API_URL } from './Config';
import { startLoading, endLoading, SnackBar, handleHTTPError, ShowLoadingSpinner, pageGifLoader } from './CommonActions';
import store from '../store';
import axios from 'axios';

export function tourList(list) {
    return {
        type: 'STORE_HOME_TOUR_LIST',
        list: list.data
    }
}

export function getHomeTours() {
    return function (dispatch) {
        dispatch(startLoading());
        dispatch(pageGifLoader(true));
        fetch(API_URL + '/api/home_details', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(tourList(json));
                    setTimeout(() => {
                        dispatch(pageGifLoader(false));
                    }, 3000);
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function homeRedUpdate(bool) {
    return {
        type: 'STORE_HOME_REDUCER_UPDATE', bool
    }
}


export function storeSpecialTours(list) {
    return {
        type: 'STORE_HOME_SPECIAL_TOURS',
        list: list.data
    }
}

export function getSpecialTours() {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/special_tours/get', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeSpecialTours(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}


export function storeDayTours(list) {
    return {
        type: 'STORE_HOME_DAY_TOURS',
        list: list.data
    }
}

export function getDayTours() {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/dayTours/get', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeDayTours(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}


export function storeRoundTours(list) {
    return {
        type: 'STORE_HOME_ROUND_TOURS',
        list: list.data
    }
}

export function getRoundTours() {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/roundTours/get', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeRoundTours(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}


export function storeMaldiveTours(list) {
    return {
        type: 'STORE_HOME_MALDIVE_TOURS',
        list: list.data
    }
}

export function getMaldiveTours() {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/maldivesTours/get', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeMaldiveTours(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}



export function storeSpecialTourList(list) {
    return {
        type: 'STORE_SPECIAL_TOURS_LISTING',
        list: list.data
    }
}

export function getAllSpecialTours() {
    return function (dispatch) {
        dispatch(startLoading());
        dispatch(pageGifLoader(true));
        fetch(API_URL + '/api/special_tours/all', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeSpecialTourList(json));
                    dispatch(pageGifLoader(false));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function storeSearchResult(list) {
    return {
        type: 'STORE_SEARCH_RESULT_LIST',
        list: list.data
    }
}

export function getSearchResult(loc, id) {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/search_result/get?location' + loc + "&id" + id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeSearchResult(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function storeHyperLinkTours(list) {
    return {
        type: 'STORE_HYPER_LINK_TOURS',
        list: list.data
    }
}

export function getHyperLinkTours() {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/hyperLinks', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeHyperLinkTours(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}
